const WithdrawSmallIcon = () => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.24984 22.3332V10.6665H17.2498V11.8332C18.0665 11.8332 18.8482 11.9498 19.5832 12.1715V10.6665C19.5832 9.38317 18.5332 8.33317 17.2498 8.33317H16.0832V5.99984C16.0832 2.77984 13.4698 0.166504 10.2498 0.166504C7.02984 0.166504 4.4165 2.77984 4.4165 5.99984V8.33317H3.24984C1.9665 8.33317 0.916504 9.38317 0.916504 10.6665V22.3332C0.916504 23.6165 1.9665 24.6665 3.24984 24.6665H10.5532C10.0632 23.9665 9.67817 23.1732 9.4215 22.3332H3.24984ZM6.74984 5.99984C6.74984 4.06317 8.31317 2.49984 10.2498 2.49984C12.1865 2.49984 13.7498 4.06317 13.7498 5.99984V8.33317H6.74984V5.99984Z"
        fill="#657589"
      />
      <path
        d="M17.2498 14.1665C14.0298 14.1665 11.4165 16.7798 11.4165 19.9998C11.4165 23.2198 14.0298 25.8332 17.2498 25.8332C20.4698 25.8332 23.0832 23.2198 23.0832 19.9998C23.0832 16.7798 20.4698 14.1665 17.2498 14.1665ZM19.1748 22.7415L16.6665 20.2332V16.4998H17.8332V19.7548L19.9915 21.9132L19.1748 22.7415Z"
        fill="#657589"
      />
    </svg>
  );
};

export default WithdrawSmallIcon;
